import cx from "classnames";
import { Alert } from "components/common/Alert/Alert";
import { Radio } from "components/common/Radio/Radio";
import { FC } from "react";
import { Image } from "react-datocms";
import { Field } from "react-final-form";
import { MachineRegistrationQuery } from "services/datocms/generated";

type MachinesListProps = {
  header?: string | null;
  machines?: NonNullable<
    MachineRegistrationQuery["machineRegistrationPage"]
  >["machines"];
};

export const MachinesList: FC<MachinesListProps> = ({ header, machines }) => {
  return (
    <div className="bg-white px-6 py-10 md:px-10 md:p-10 rounded-[20px] md:border border-gray-200 flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">{header}</h2>
      <Field
        name="itemId"
        render={({ input, meta }) => (
          <>
            {meta.touched && meta.error && (
              <Alert type="error">{meta.error}</Alert>
            )}
            <div {...input}>
              <div className="flex flex-wrap gap-6">
                {machines?.map((machine) => {
                  return (
                    <div
                      key={machine.id}
                      className="flex flex-col gap-2 cursor-pointer"
                      onClick={() => input.onChange(machine.gtin)}
                    >
                      <div
                        className={cx(
                          "w-[164px] h-[164px] bg-secondary bg-opacity-20 relative flex justify-center items-center rounded-[20px]",
                          input.value &&
                            input.value === machine.gtin &&
                            "outline outline-[3px] outline-primary",
                        )}
                      >
                        <div className="absolute top-3 left-3">
                          <Radio
                            readOnly
                            checked={
                              input.value && input.value === machine.gtin
                            }
                          />
                        </div>
                        <div className="h-full overflow-hidden w-3/5 relative">
                          {machine.image?.responsiveImage && (
                            <Image
                              layout="fill"
                              objectFit="cover"
                              data={machine.image?.responsiveImage}
                            />
                          )}
                        </div>
                      </div>
                      <p className="font-semibold text-[21px]">
                        {machine.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      ></Field>
    </div>
  );
};
